"use client";

import {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from "react";

export interface Template {
  description: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fields: any[];
  name: string;
  sample_url: string;
  placeholder_url: string;
  id: number;
}

interface TemplateContextType {
  chosenTemplate: Template | null;
  setChosenTemplate: (template: Template | null) => void;
  generatedTemplate: string | null;
  setGeneratedTemplate: (template: string | null) => void;
  generatedCaption: string | null;
  setGeneratedCaption: (caption: string | null) => void;
}

const TemplateContext = createContext<TemplateContextType | undefined>(
  undefined
);

export function TemplateProvider({ children }: { children: ReactNode }) {
  const [chosenTemplate, setChosenTemplate] = useState<Template | null>(null);
  const [generatedTemplate, setGeneratedTemplate] = useState<string | null>(
    null
  );
  const [generatedCaption, setGeneratedCaption] = useState<string | null>(null);
  // Load chosen template from localStorage on mount
  useEffect(() => {
    const savedTemplate = localStorage.getItem("chosenTemplate");
    if (savedTemplate) {
      try {
        setChosenTemplate(JSON.parse(savedTemplate));
      } catch (error) {
        console.error("Error parsing saved template:", error);
        localStorage.removeItem("chosenTemplate");
      }
    }
  }, []);

  // Save chosen template to localStorage whenever it changes
  useEffect(() => {
    if (chosenTemplate) {
      localStorage.setItem("chosenTemplate", JSON.stringify(chosenTemplate));
    } else {
      localStorage.removeItem("chosenTemplate");
    }
  }, [chosenTemplate]);

  return (
    <TemplateContext.Provider
      value={{
        chosenTemplate,
        setChosenTemplate,
        generatedTemplate,
        setGeneratedTemplate,
        generatedCaption,
        setGeneratedCaption,
      }}
    >
      {children}
    </TemplateContext.Provider>
  );
}

export function useTemplates() {
  const context = useContext(TemplateContext);
  if (context === undefined) {
    throw new Error("useTemplates must be used within a TemplateProvider");
  }
  return context;
}
